export default __webpack_public_path__ + "static/arindamLehri15-d7f8d7094fcad138cab61d1e2d446cde.jpg";